<template>
  <div class="VipCard">
    <div v-if="carList.length === 0" class="notcot">
      <div class="ntbox">
        <img :src="require('@/assets/images/icon/enpty.png')" />
        <br />
        <span>还没有记录哦~</span>
      </div>
    </div>
    <ul class="car-list">
      <li v-for="v in carList" :key="v.id">
        <div class="cell-li">
          <div class="left">
            <span class="small">￥</span>
            <span class="big">{{v.card.cardMoney|priceFilter}}</span>
          </div>
          <div class="middle">
            <span class="big cname">{{v.card.cardName}}</span>
            <span class="use-rule" @click="handleCheck(v)">
              使用规则
              <van-icon name="arrow-down" :class="selectId==v.id?'active':''" />
            </span>
          </div>
          <div class="right">
            <van-button @click="getAward(v)">领取</van-button>
          </div>
        </div>
        <transition name="van-slide-down">
          <div class="later" v-if="selectId==v.id">
                <span
              v-html="
                v.card.useRule
                  ? v.card.useRule.replace(/\n/g, '<br>')
                  : ''
              "></span>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "GetCard",
  data () {
    return {
      carList: [],
      selectId: null,
      type: 1,
      mobile: ''
    };
  },
  computed: {},
  async mounted () {
    let res;
    if (this.isWechat) {
      res = await this.getUser();
      console.log(res);
      if (res.data.mobile === '') {
        this.go(`/bindIphone?id=${this.$route.query.id}`);
        return;
      } else {
        this.mobile = res.data.mobile;
      }
    }
    if (!this.isWechat && !this.$route.query.mobile && this.$route.query.cardNewUserId) {
      this.go(`/addCar?id=${this.$route.query.cardNewUserId}&type=7`);
      return;
    }
    this.userCardList();
    // if (this.$route.query.id) {
    //   // 新人券
    //   this.type = 1;
    // }
    // if (this.$route.query.cardNewUserId) {
    //   // 权益券
    //   this.type = 2;
    // }
  },
  methods: {
    // 查看使用规则
    handleCheck (v) {
      if (this.selectId === v.id) this.selectId = null;
      else this.selectId = v.id;
    },
    // 领取
    async getAward (v) {
      if (!this.isWechat && !this.$route.query.mobile) {
        this.go(`/addCar?id=${v.cardNewUserId}&type=7`);
      };
      // 领取免费券
      let url = "/user/userCard/addNewUserCard";
      // 1新人发券 2指定用户 3权益劵 4生成劵码
      // if (this.type === 2 && this.isWechat) {
      if (v.type === 3 && this.isWechat) {
        // 权益券 微信环境
        url = "/user/userCard/addRightsNewUserCard";
      // } else if (this.type === 1 && !this.isWechat) {
      } else if (v.type !== 3 && !this.isWechat) {
        // 免费券 非微信环境
        url = "/pay/userOrder/addNewUserCard";
      } else if (v.type === 3 && !this.isWechat) {
        // 权益券 非微信环境
        url = "/pay/userOrder/addRightsNewUserCard";
      }
      // 11/17 需求1
      if (v.type === 2) {
        // 指定用户发券 领券
        url = "/pay/userOrder/addNewCardSpec";
        this.mobile = this.mobile ? this.mobile : this.$route.query.mobile;
      }
      // user/userCard/addNewUserCard
      let res = await this.request(url, {
        newUserCardId: v.id,
        userPhone: v.type === 2 ? this.mobile : this.$route.query.mobile ? this.$route.query.mobile : ''
      });
      console.log('res', res);
      if (res.code === 0) {
        this.$error("领取成功");
        // let self = this;
        setTimeout(() => {
          let href = this.getStore('href');
          this.removeStore('href');
          console.log('get href', href);
          if (href) {
          window.location.href = href;
          } else {
            if (this.isWechat) {
              this.go('/VipCard');
            } else {
              this.$error('领取成功，请您前往公众号使用');
            }
          }
        }, 1500);
        // if (this.type === 2 && !this.isWechat) {

        // } else {
        //   setTimeout(() => {
        //     self.go('/personalcenter');
        //   }, 500);
        // }
      } else {
        this.$error(res.msg);
        // this.$error('无法领取');
        setTimeout(() => {
          let href = this.getStore('href');
          this.removeStore('href');
          console.log('get href', href);
          // if (href)window.location.href = href;
          if (href) {
          window.location.href = href;
          } else {
            if (this.isWechat) {
              this.go('/VipCard');
            } else {
              // this.$error('领取成功，请您前往公众号使用');
            }
          }
        }, 1500);
        // let self = this;
        // // 跳转回到正确的领取页
        // setTimeout(() => {
        //   self.go('/personalcenter');
        // }, 500);
      }
    },
    async userCardList () {
      try {
        this.$loading("加载中");
        let res = await this.request("/card/cardNewUser/getInfo", {
          cardNewUserId: this.$route.query.cardNewUserId ? this.$route.query.cardNewUserId : this.$route.query.id
        });
        console.log(res);
        this.$loadingClose();
        this.carList = res.data;
        // this.carList = res.data.map(it => {
        //   return {
        //     ...it
        //   };
        // });
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.ntbox {
  padding-top: 50%;
  color: #bbbbbb;
}
.notcot {
  width: 100%;
  height: 100vh;
  background-color: #f8f8f8;
  text-align: center;
}
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.car-list {
  margin-top: 15px;
  li {
    overflow: hidden;
    margin-bottom: 20px;
    .cell-li {
      .flex-center();
      position: relative;
      flex-wrap: wrap;
      justify-content: space-between;
      background: rgb(236, 247, 255);
      margin: 0 20px;
      padding: 10px 15px;
      .left {
        width: 60px;
        span {
          color: #0096ff;
          font-size: 14px;
          &.big {
            font-size: 22px;
          }
        }
      }
      .middle {
        width: 150px;
        margin-right: 5px;
        border-right: 2px dashed #0096ff;
        padding: 0 15px;
        width: 35%;
        flex: 1;
        span {
          display: block;
          &.big {
            color: #055790;
            font-size: 15px;
            padding-bottom: 8px;
          }
          &.use-rule {
            color: #585858;
            .van-icon {
              transition: transform 0.3s;
            }
          }
          .active {
            transform: rotate(-180deg);
          }
        }
      }
      .right {
        margin-left: 15px;
        .van-button {
          background: linear-gradient(
            90deg,
            rgba(66, 177, 255, 1) 0%,
            rgba(26, 156, 253, 1) 100%
          );
          font-size: 12px;
          color: #fff;
          padding: 0 20px;
          height: 25px;
          line-height: 25px;
          display: block;
          border-radius: 20px;
          margin-bottom: 5px;
        }
      }
    }
    .later {
      background: #f7fbff;
      margin: 0 20px;
      padding: 10px;
      position: relative;
      z-index: -1;
    }
  }
  .cname {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>